import { render, staticRenderFns } from "./oldBrowser.vue?vue&type=template&id=7a8072df&scoped=true"
import script from "./oldBrowser.vue?vue&type=script&lang=js"
export * from "./oldBrowser.vue?vue&type=script&lang=js"
import style0 from "./oldBrowser.vue?vue&type=style&index=0&id=7a8072df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8072df",
  null
  
)

export default component.exports